module.exports = __webpack_public_path__ + "img/6.84c3e1de.png";